import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import "../../../assets/css/SalesTrend/MonthlyPerformance.css";
import ArrowUpwardIcon from "../../../assets/images/ArrowUpwardIcon_green.svg";
import ArrowDownwardIcon from "../../../assets/images/ArrowDownwardIcon_red.svg";
import * as XLSX from "xlsx";
import { useSalesContext } from "../../SalesContext";
import MonthSelectorDropdown from "../../MonthSelectorDropdown";
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

const MonthlyPerformance = () => {
  const defaultCard5Data = {
    Quarters: {
      Q1: {
        January: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        February: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        March: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
      },
      Q2: {
        April: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        May: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        June: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
      },
      Q3: {
        July: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        August: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        September: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
      },
      Q4: {
        October: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        November: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
        December: {
          LLY: 0,
          LY: 0,
          LY_Grw: 0,
          Target: 0,
          CY: 0,
          Per_Ach: 0,
          CY_Growth: 0,
          CAGR: 0,
          Balance: 0,
        },
      },
    },
    GrandTotal: {
      LLY: 0,
      LY: 0,
      LY_Grw: 0,
      Target: 0,
      CY: 0,
      Per_Ach: 0,
      CY_Growth: 0,
      CAGR: 0,
      Balance: 0,
    },
  };

  const { kpiData, salesUnit, loading } = useSalesContext();
  const [title, setTitle] = useState("Monthly Performance");
  const card5Data =
    kpiData?.kpi_data?.card5_monthly_performance || defaultCard5Data;
  const card5DataArray = [card5Data.Quarters];
  const card5DataArray2 = [card5Data.GrandTotal];
  const quarters = Object.keys(card5DataArray[0]).sort((a, b) => {
    const quarterOrder = ["Q1", "Q2", "Q3", "Q4"];
    return quarterOrder.indexOf(a) - quarterOrder.indexOf(b);
  });

  const groupedData = quarters.reduce((acc, quarter) => {
    acc[quarter] = Object.keys(card5DataArray[0][quarter]).map((month) => ({
      quarter,
      month,
      ...card5DataArray[0][quarter][month],
    }));
    return acc;
  }, {});

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [selectedMonths, setSelectedMonths] = useState<string[]>(months);
  const [filteredData, setFilteredData] = useState(groupedData);
  const [viewMode, setViewMode] = useState("monthly");

  useEffect(() => {
    setFilteredData(groupedData);
  }, [kpiData]);

  if (loading || !kpiData) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  function formatNumberToRupees(number: number) {
    if (isNaN(number) || !isFinite(number)) return "";
    if (salesUnit === "Crores") {
      return (number / 10000000).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else if (salesUnit === "Lacs") {
      return (number / 100000).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      return number.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }

  const handleViewModeChange = (event: { target: { value: any } }) => {
    const newViewMode = event.target.value;
    setViewMode(newViewMode);
    setTitle(
      newViewMode === "quarterly"
        ? "Quarterly Performance"
        : "Monthly Performance"
    );
    if (newViewMode === "quarterly") {
      const newFilteredData = quarters.reduce((acc, quarter) => {
        acc[quarter] = groupedData[quarter].filter(
          (row: { month: string }) => row.month === "Total"
        );
        return acc;
      }, {});
      setFilteredData(newFilteredData);
    } else {
      // Apply month filtering based on selectedMonths
      const newFilteredData =
        selectedMonths.length === months.length || selectedMonths.length === 0
          ? groupedData
          : quarters.reduce((acc, quarter) => {
              acc[quarter] = groupedData[quarter].filter(
                (row: { month: string }) => selectedMonths.includes(row.month)
              );
              return acc;
            }, {});
      setFilteredData(newFilteredData);
    }
  };

  const handleApplyMonths = (newSelectedMonths: string[]) => {
    setSelectedMonths(newSelectedMonths);
    const newFilteredData =
      newSelectedMonths.length === 0 ||
      newSelectedMonths.length === months.length
        ? groupedData
        : quarters.reduce((acc, quarter) => {
            acc[quarter] = groupedData[quarter].filter(
              (row: { month: string }) => newSelectedMonths.includes(row.month)
            );
            return acc;
          }, {});
    setFilteredData(newFilteredData);
  };

  // const handleDownload = (e) => {
  //   e.preventDefault();
  //   console.log("Download button clicked", e);
  //   const data = [];
  //   debugger;
  //   const formatCurrency = (value) => {
  //     return (Math.abs(value) / 100000).toFixed(2);
  //   };

  //   const formatPercentage = (value) => {
  //     return `${Math.abs(value).toFixed(2)}%`;
  //   };

  //   for (const quarter in groupedData) {
  //     groupedData[quarter].forEach((row) => {
  //       const newRow = { ...row };
  //       for (const key in newRow) {
  //         if (newRow[key] === "NaN" || newRow[key] === "Infinity") {
  //           newRow[key] = "";
  //         }
  //       }
  //       data.push(newRow);
  //     });
  //   }

  //   if (card5DataArray2.length > 0) {
  //     const grandTotalRow = { quarter: "Grand_Total", ...card5DataArray2[0] };
  //     for (const key in grandTotalRow) {
  //       if (grandTotalRow[key] === "NaN" || grandTotalRow[key] === "Infinity") {
  //         grandTotalRow[key] = "";
  //       }
  //     }
  //     data.push(grandTotalRow);
  //   }

  //   data.forEach((row) => {
  //     if (row.LY_Grw) row.LY_Grw = formatPercentage(row.LY_Grw);
  //     if (row.CY_Growth) row.CY_Growth = formatPercentage(row.CY_Growth);
  //     if (row.Per_Ach) row.Per_Ach = formatPercentage(row.Per_Ach);
  //     if (row.CAGR) row.CAGR = formatPercentage(row.CAGR);
  //   });

  //   data.forEach((row) => {
  //     if (row.LLY) row.LLY = formatCurrency(row.LLY);
  //     if (row.LY) row.LY = formatCurrency(row.LY);
  //     if (row.Target) row.Target = formatCurrency(row.Target);
  //     if (row.CY) row.CY = formatCurrency(row.CY);
  //     if (row.Balance) row.Balance = formatCurrency(row.Balance);
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(data);
  //   const csvString = XLSX.utils.sheet_to_csv(worksheet);
  //   const base64Csv = btoa(unescape(encodeURIComponent(csvString)));

  //   const message = {
  //     type: "DOWNLOAD_CSV",
  //     csv: base64Csv,
  //     fileName: "SalesTrend_Data_Report.csv",
  //     mimeType: "text/csv",
  //   };

  //   const isReactNativeWebView = !!window.ReactNativeWebView;
  //   const isInIframe = window.self !== window.top;

  //   if (isReactNativeWebView) {
  //     window.ReactNativeWebView.postMessage(JSON.stringify(message));
  //   } else if (isInIframe) {
  //     window.parent.postMessage(
  //       JSON.stringify(message),
  //       "https://bsvdashqa.mankindpharma.in"
  //     );
  //   } else {
  //     // Regular web browser download
  //     const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  //     const url = URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = "SalesTrend_Data_Report.csv";
  //     a.click();
  //     URL.revokeObjectURL(url);
  //     alert("File downloaded successfully!");
  //   }
  // };
const handleDownload = (e) => {
  e.preventDefault();
  console.log("Download button clicked", e);
  const data = [];

  const formatCurrency = (value) => (Math.abs(value) / 100000).toFixed(2);
  const formatPercentage = (value) => `${Math.abs(value).toFixed(2)}%`;

  for (const quarter in groupedData) {
    groupedData[quarter].forEach((row) => {
      const newRow = { ...row };
      for (const key in newRow) {
        if (newRow[key] === "NaN" || newRow[key] === "Infinity") {
          newRow[key] = "";
        }
      }
      data.push(newRow);
    });
  }

  if (card5DataArray2.length > 0) {
    const grandTotalRow = { quarter: "Grand_Total", ...card5DataArray2[0] };
    for (const key in grandTotalRow) {
      if (grandTotalRow[key] === "NaN" || grandTotalRow[key] === "Infinity") {
        grandTotalRow[key] = "";
      }
    }
    data.push(grandTotalRow);
  }

  data.forEach((row) => {
    if (row.LY_Grw) row.LY_Grw = formatPercentage(row.LY_Grw);
    if (row.CY_Growth) row.CY_Growth = formatPercentage(row.CY_Growth);
    if (row.Per_Ach) row.Per_Ach = formatPercentage(row.Per_Ach);
    if (row.CAGR) row.CAGR = formatPercentage(row.CAGR);
  });

  data.forEach((row) => {
    if (row.LLY) row.LLY = formatCurrency(row.LLY);
    if (row.LY) row.LY = formatCurrency(row.LY);
    if (row.Target) row.Target = formatCurrency(row.Target);
    if (row.CY) row.CY = formatCurrency(row.CY);
    if (row.Balance) row.Balance = formatCurrency(row.Balance);
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const csvString = XLSX.utils.sheet_to_csv(worksheet);
  const base64Csv = btoa(unescape(encodeURIComponent(csvString)));

  const message = {
    type: "DOWNLOAD_CSV",
    csv: base64Csv,
    fileName: "SalesTrend_Data_Report.csv",
    mimeType: "text/csv",
  };

  const isReactNativeWebView = !!window.ReactNativeWebView;
  const isInIframe = window.self !== window.top;

  const getTargetOrigin = () => {
    if (window.location.hostname.includes("qa")) {
      return "https://bsvdashqa.mankindpharma.in";
    } else if (window.location.hostname.includes("uat")) {
      return "https://bsvdashuat.mankindpharma.in";
    } else {
      return "https://bsvdashprod.mankindpharma.in";
    }
  };

  if (isReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
  } else if (isInIframe) {
    try {
      // ✅ Generate XLSX inside iframe
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "SalesTrend");
      XLSX.writeFile(workbook, "SalesTrend_Data_Report.xlsx");

      // ✅ Notify parent dynamically
      window.parent.postMessage(JSON.stringify(message), getTargetOrigin());
    } catch (error) {
      console.error("Error generating XLSX inside iframe:", error);
    }
  } else {
    // ✅ Regular browser download
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "SalesTrend_Data_Report.csv";
    a.click();
    URL.revokeObjectURL(url);
    alert("File downloaded successfully!");
  }
};

  const renderValueWithIndicator = (value: number, isPercentage = false) => {
    if (value === 0) {
      return (
        <Box className="valueIndicator" sx={{ color: "black" }}>
          <span>{isPercentage ? "0.00%" : "0.00"}</span>
        </Box>
      );
    }
    const color = value >= 0 ? "#4CAF50" : "#F44336";
    const ArrowIcon = value >= 0 ? ArrowUpwardIcon : ArrowDownwardIcon;
    const formattedValue = isPercentage
      ? Number(Math.abs(value)).toFixed(2) + "%"
      : Number(Math.abs(value)).toFixed(2);

    return (
      <Box className="valueIndicator" sx={{ color }}>
        <img src={ArrowIcon} alt={value >= 0 ? "Up" : "Down"} />
        <span>{formattedValue}</span>
      </Box>
    );
  };

  return (
    <Box className="monthly-card">
      <Box className="header">
        <Box className="title-container">
          <Typography className="title">
            {title} ({salesUnit || "Lacs"})
          </Typography>
        </Box>
        <Box className="controls">
          <FormControl className="view-mode-control">
            <RadioGroup
              className="quaterly"
              row={false}
              value={viewMode}
              onChange={handleViewModeChange}
            >
              <FormControlLabel
                value="quarterly"
                control={<Radio />}
                label={
                  <Typography className="view-mode-label">Quarterly</Typography>
                }
              />
              <FormControlLabel
                value="monthly"
                control={<Radio />}
                label={
                  <Typography className="view-mode-label">Monthly</Typography>
                }
              />
            </RadioGroup>
          </FormControl>
          {viewMode === "monthly" && (
            <MonthSelectorDropdown
              months={months}
              selectedMonths={selectedMonths}
              onApply={handleApplyMonths}
              label="Month"
            />
          )}
          <Button
            variant="contained"
            onClick={handleDownload}
            className="download-button"
          >
            Download MIS
          </Button>
        </Box>
      </Box>

      <TableContainer component={Paper} className="table-container">
        <Table stickyHeader size="small">
          <TableHead className="table-head">
            <TableRow>
              <TableCell
                className="table-quarter-cell sticky-cell"
                style={{ position: "sticky", left: 0, zIndex: 100 }}
              >
                Qtr.
              </TableCell>
              {viewMode === "monthly" && (
                <TableCell
                  className="table-cell sticky-month "
                  style={{ position: "sticky", left: 50, zIndex: 100 }}
                >
                  Month
                </TableCell>
              )}
              {[
                "LLY",
                "LY",
                "LY Grw",
                "Target",
                "CY",
                "%Ach",
                "CY Grw",
                "CAGR",
                "Balance to do",
              ].map((header) => (
                <TableCell key={header}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {quarters.map(
              (quarter) =>
                quarter !== "GrandTotal" && (
                  <React.Fragment key={`${quarter}-section`}>
                    {filteredData[quarter] &&
                      filteredData[quarter].length > 0 &&
                      filteredData[quarter].map((row, index) => (
                        <TableRow key={`${row.quarter}-${row.month}`}>
                          {index === 0 && (
                            <TableCell
                              rowSpan={filteredData[quarter].length.toString()}
                              className="table-quarter-cell sticky-cell"
                            >
                              {row.quarter}
                            </TableCell>
                          )}
                          {viewMode === "monthly" && (
                            <TableCell
                              className={`table-cell sticky-month ${
                                row.month === "Total"
                                  ? "total-cell"
                                  : "regular-cell-2"
                              }`}
                              style={{ fontWeight: "bold" }}
                            >
                              {row.month}
                            </TableCell>
                          )}
                          {[
                            "LLY",
                            "LY",
                            "LY_Grw",
                            "Target",
                            "CY",
                            "Per_Ach",
                            "CY_Growth",
                            "CAGR",
                            "Balance",
                          ].map((key) => (
                            <TableCell
                              key={key}
                              className={`table-cell ${
                                row.month === "Total"
                                  ? "total-cell"
                                  : "regular-cell"
                              }`}
                            >
                              {key.includes("Grw") ||
                              key.includes("Ach") ||
                              key.includes("Growth") ||
                              key.includes("CAGR")
                                ? isNaN(row[key]) || !isFinite(row[key])
                                  ? ""
                                  : renderValueWithIndicator(row[key], true)
                                : formatNumberToRupees(row[key])}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  </React.Fragment>
                )
            )}
            {selectedMonths.length === months.length && (
              <TableRow className="grand-total-row">
                <TableCell
                  colSpan={viewMode === "monthly" ? 2 : 1}
                  className="table-cell sticky-cell total-cell"
                >
                  Grand Total
                </TableCell>
                {[
                  "LLY",
                  "LY",
                  "LY_Grw",
                  "Target",
                  "CY",
                  "Per_Ach",
                  "CY_Growth",
                  "CAGR",
                  "Balance",
                ].map((key) => (
                  <TableCell key={key} className="table-cell total-cell">
                    {key.includes("Grw") ||
                    key.includes("Ach") ||
                    key.includes("Growth") ||
                    key.includes("CAGR")
                      ? isNaN(card5DataArray2[0][key]) ||
                        !isFinite(card5DataArray2[0][key])
                        ? ""
                        : renderValueWithIndicator(
                            card5DataArray2[0][key],
                            true
                          )
                      : formatNumberToRupees(card5DataArray2[0][key])}
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default MonthlyPerformance;
